import styled from "styled-components";
import { IMAGES } from "../../../constants/images";
import ExpendedButton from "./ExpendedButton";
import BufferItem from "./BufferItem";

export default function ExpandedMenu({
  toggleDrawModeHome,
  drawMode,
  isExpanded = true,
  handleExpanded,
  applyPreset,
  country,
  deleteDisabled,
  handleContextualDelete,
  bufferDistances,
  handlePlus,
  handleMinus,
  setBufferDistances,
}) {
  return (
    <ExpendedMenuContainer>
      <ExpendedButton onClick={toggleDrawModeHome} isActive={drawMode.home === "draw_polygon"} isExpanded={isExpanded} handleExpanded={handleExpanded} />
      {isExpanded && (
        <>
          <div className="selector-buttons">
            <CountryItem onClick={() => applyPreset("US")} title="Apply US/UK preset" isActiveCountry={country === "US"}>
              <img src={IMAGES.UK_FLAG} alt="US/UK Flag" />
            </CountryItem>
            <CountryItem onClick={() => applyPreset("GR")} title="Apply Greece preset" isActiveCountry={country === "GR"}>
              <img src={IMAGES.GR_FLAG} alt="GR Flag" />
            </CountryItem>
            <CountryItem onClick={() => applyPreset("FR")} title="Apply France preset" isActiveCountry={country === "FR"}>
              <img src={IMAGES.FR_FLAG} alt="FR Flag" />
            </CountryItem>
          </div>
          <button className="clear-btn" disabled={deleteDisabled} onClick={handleContextualDelete}>
            <img src={IMAGES.BIN} alt="Bin" />
          </button>
          {bufferDistances.map((buffer, index) => (
            <BufferItem
              key={index}
              title={`${index + 1} -`}
              value={buffer === 0 ? "" : buffer}
              onPlus={() => handlePlus(index)}
              onMinus={() => handleMinus(index)}
              disabled={bufferDistances.length === 1}
              onDelete={() => {
                const newDistances = bufferDistances.filter((_, i) => i !== index);
                setBufferDistances(newDistances);
              }}
              onChange={(e) => {
                const newDistances = [...bufferDistances];
                newDistances[index] = parseFloat(e.target.value) || 0;
                setBufferDistances(newDistances);
              }}
            />
          ))}
          {bufferDistances.length < 10 && (
            <button className="add-buffer-btn" onClick={() => setBufferDistances([...bufferDistances, bufferDistances[bufferDistances.length - 1] + 10])}>
              + Add buffer
            </button>
          )}
        </>
      )}
    </ExpendedMenuContainer>
  );
}

const ExpendedMenuContainer = styled.div`
  display: grid;
  gap: 5px;

  .selector-buttons {
    display: flex;
    gap: 3px;
    margin-top: 5px;
    width: 80%;
    margin: 0 auto;
  }

  .clear-btn {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    width: 80%;
    margin: 0 auto;
    background-color: white;
    border-radius: 5px;
    cursor: pointer;
  }

  .clear-btn img {
    height: 16px;
  }

  .clear-btn:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .add-buffer-btn {
    all: unset;
    color: #0f77ffff;
    font-weight: bold;
    cursor: pointer;
    height: 24px;
  }
`;

const CountryItem = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: white;
  box-sizing: border-box;
  border: 2px solid ${({ isActiveCountry }) => (isActiveCountry ? "#0f77ffff" : "transparent")};
`;
